import { TRANSLATION_STATUS, TranslationStatus } from 'types/translations'

export const mapTranslationStatus = (
  backendStatus: string
): TranslationStatus => {
  switch (backendStatus) {
    case 'pending':
      return TRANSLATION_STATUS.pending
    case 'processing':
      return TRANSLATION_STATUS.validating
    case 'completed':
      return TRANSLATION_STATUS.completed
    case 'partial_success':
      return TRANSLATION_STATUS.completed
    case 'failed':
      return TRANSLATION_STATUS.failed
    default:
      return TRANSLATION_STATUS.pending
  }
}
